/* global  */ // tUrl等のグローバル変数を宣言する

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

if ($('.js-topSlide')[0]) {
  // eslint-disable-next-line no-unused-vars
  const topSlide = new Swiper('.js-topSlide', {
    centeredSlides: true,
    //slidePerView: 1,
    spaceBetween: 15,
    breakpoints: {
      // 768px以上の場合
      768: {
        centeredSlides: false,
        slidesPerView: 2,
        //spaceBetween: 28,
      },
    },
    loop: true,
    pagination: {
      el: '.js-topSlide-page',
      clickable: true,
    },
    navigation: {
      nextEl: '.js-topSlide-next',
      prevEl: '.js-topSlide-prev',
    },
  })
}
